<main class="page-container__body">
    <div class="container-fluid">
        <div class="body-area">
            <div class="page-header">
                <h1>Auction Scheduler</h1>
                <hr class="hr-highlight" />
            </div>
            <form class="calendar-box">
                <full-calendar [options]="calendarOptions"></full-calendar>
            </form>
        </div>
    </div>
    <ng-template #templateAuctionDetails class="modal-lg" style="width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title pull-left">Auction Details</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Total Vehicles
                        <span class="">{{filterRecord?.VehicleCount}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Auction Start Date
                        <span class="">{{filterRecord?.StartDate | date:'MMM d, y, h:mm a'}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Auction End Date
                        <span class="">{{filterRecord?.EndDate | date:'MMM d, y, h:mm a'}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Location
                        <span class="">{{filterRecord?.StorageLocationName + ', ' + filterRecord?.StorageLocationAddress}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        Seller
                        <span class="">{{filterRecord?.EnterpriseName}}</span>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeModal()">Close</button>
                <a (click)="continue()">Click here to view the vehicles</a>
            </div>
        </div>
    </ng-template>
</main>